// src/components/PublicationCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

const PublicationCard = ({ publication, featured = false }) => {
  // Construct the image path
  const imagePath = `/images/publications/${publication.id}/main.png`;
  
  return (
    <Link to={`/publications/${publication.id}`} className="publication-card-link">
      <div className={`publication-card ${featured ? 'featured' : ''}`}>
        {/* Publication Image */}
        <div className="publication-image">
          <img 
            src={imagePath} 
            alt={publication.title}
            className="publication-image-content"
            onError={(e) => {
              // Fallback if image doesn't exist
              e.target.style.display = 'none';
              e.target.nextElementSibling.style.display = 'flex';
            }}
          />
          <div className="image-fallback">
            <span className="fallback-text">{publication.category}</span>
          </div>
          
          {featured && (
            <div className="featured-badge">
              Featured
            </div>
          )}
          
          <div className="category-badge">
            {publication.category}
          </div>
        </div>
        
        <div className="publication-content">
          <h3>{publication.title}</h3>
          <p>{publication.excerpt}</p>
          
          <div className="publication-meta">
            <div className="meta-item">
              <Calendar size={14} />
              <span>{new Date(publication.date).toLocaleDateString('en-US', { 
                month: 'short', 
                day: 'numeric', 
                year: 'numeric' 
              })}</span>
            </div>
            <div className="meta-item">
              <Clock size={14} />
              <span>{publication.readTime}</span>
            </div>
          </div>
          
          <div className="publication-tags">
            {publication.tags.slice(0, 3).map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
          
          <div className="read-more">
            Read Article
            <ArrowRight size={16} />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PublicationCard;